import {
  OptinItemEditType,
  OptinItemUpdateType,
} from 'modules/stores/store/content/optin/types/optin-interface'
import { getComplexItemUpdateData } from 'modules/stores/store/utils/get-complex-item-update-data'

export const getOptinUpdateData = (data: OptinItemEditType): OptinItemUpdateType => ({
  ...getComplexItemUpdateData(data),
  fields: data.fields.map(({ slug, required }) => ({ slug, required })),
  thankYouPage: {
    title: data.thankYouPage.title,
    text: data.thankYouPage.text,
  },
})
